function accordion_js() {
  const accordionWrappers = document.querySelectorAll(".accordions");

  if (!accordionWrappers.length) {
    return;
  }

  // Accordion state classes
  const classes = {
    active: "c-accordion--active",
    animated: "c-accordion--animated",
  };

  let expandTimeout;

  /**
   * Get the trigger and content elements of an accordion.
   *
   * @param {HTMLElement} accordion - The accordion element.
   * @returns {Object} - Object containing trigger and content elements.
   */
  const getAccordionElements = (accordion) => {
    const trigger = accordion.querySelector(".c-accordion__trigger");
    const content = accordion.querySelector(".c-accordion__content");

    return { trigger, content };
  };

  /**
   * Expand the accordion item.
   *
   * @param {HTMLElement} accordion - The accordion element.
   * @param {HTMLElement} trigger - The trigger element.
   * @param {HTMLElement} content - The content element.
   */
  const expand = (accordion, trigger, content) => {
    clearTimeout(expandTimeout);

    trigger.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
    accordion.classList.add(classes.active);

    expandTimeout = setTimeout(() => {
      accordion.classList.add(classes.animated);
    }, 300);

    content.style.maxHeight = `${content.scrollHeight}px`;
  };

  /**
   * Collapse the accordion item.
   *
   * @param {HTMLElement} accordion - The accordion element.
   * @param {HTMLElement} trigger - The trigger element.
   * @param {HTMLElement} content - The content element.
   */
  const collapse = (accordion, trigger, content) => {
    if (!accordion.classList.contains(classes.active)) {
      return;
    }
    clearTimeout(expandTimeout);

    trigger.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
    accordion.classList.remove(classes.active, classes.animated);
    content.style.maxHeight = "";
  };

  /**
   * Resizes the active accordion item.
   *
   * @returns {void}
   */
  const resizeActiveAccordion = (wrapper) => {
    const activeAccordion = wrapper.querySelectorAll(`.${classes.active}`);

    if (!activeAccordion.length) {
      return;
    }

    activeAccordion.forEach((accordion) => {
      const resizeElem = accordion.querySelector(".c-accordion__content");
      const currentHeight = parseInt(resizeElem.style.maxHeight);
      if (currentHeight === resizeElem.scrollHeight) {
        return;
      }
      resizeElem.style.maxHeight = `${resizeElem.scrollHeight}px`;
    });
  };

  /**
   * Debounced resize function to handle window resize events.
   */
  const debounce = (func, delay) => {
    let timeoutId;

    return function (...args) {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const debouncedResize = debounce((wrapper) => {
    resizeActiveAccordion(wrapper);
  }, 100);

  // Init each accordion on the page.
  const initializeAccordions = (wrappers) => {
    wrappers.forEach((wrapper) => {
      wrapper.classList.add("accordions--initialized");
      const accordions = wrapper.querySelectorAll(".c-accordion");
      const autoClose = wrapper.getAttribute("data-autoclose");

      accordions.forEach((accordion) => {
        const { trigger, content } = getAccordionElements(accordion);

        if (accordion.classList.contains(classes.animated)) {
          setTimeout(() => {
            expand(accordion, trigger, content);
            window.addEventListener("resize", () => debouncedResize(wrapper));
          }, 150);
        }

        trigger.addEventListener("click", (event) => {
          event.preventDefault();

          if (
            trigger.closest(".c-accordion").classList.contains(classes.active)
          ) {
            window.removeEventListener("resize", () =>
              debouncedResize(wrapper),
            );
            collapse(accordion, trigger, content);
          } else {
            if (autoClose !== "false") {
              // Close all active accordions within wrapper before opening new one.
              accordions.forEach((accordion) => {
                const { trigger, content } = getAccordionElements(accordion);
                collapse(accordion, trigger, content);
              });
            }
            window.removeEventListener("resize", () =>
              debouncedResize(wrapper),
            );
            expand(accordion, trigger, content);
          }
        });
      });
    });
  };

  initializeAccordions(accordionWrappers);

  document.addEventListener("cartContentUpdated", function () {
    const accordions = document.querySelectorAll(
      ".accordions:not(.accordions--initialized)",
    );
    initializeAccordions(accordions);
  });
}

accordion_js();
